/*
Notes: 
1) I'm saving query data from Admin using globalService, but this doesn't survive a page refresh.
-> alternative is to use local storage, but there are limits.
*/

import {
    AfterViewInit,
    ChangeDetectorRef,
    ChangeDetectionStrategy,
    Component,
    OnInit,
    ViewChild,
    Inject,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableExporterDirective } from "mat-table-exporter";

import { IWorkRequestQueryOptions, WorkRequest } from "@app-models/work-request";

import { PagingOpts, ScreenConfig} from "@app-models/common";
import { AzureUser } from "@app-models/azure-user";
import {
    getCurrentUserFromStorage,

    setFilterInStorage,
    getFilterFromStorage,
    setPreviousViewInStorage,
    setScreenModeInStorage,
} from "@app/utils/storage-utils";
import { GlobalConstants } from "@app/utils/global-constants";
import { GlobalService } from "@app-services/global.services";

import { NgxSpinnerService } from "ngx-spinner";
import { FormControl } from "@angular/forms";
import { UtcConverterService } from "@app/services/utc-converter.service";
import { FeedbackService } from "@app/services/feedback.service";
import { IWorkRequestFeedback } from "@app/models/feedback";
import { APP_BASE_HREF, PlatformLocation } from "@angular/common";
@Component({
    selector: "app-feedback-view",
    templateUrl: "./feedback-view.component.html",
    styleUrls: ["./feedback-view.component.scss"],
    changeDetection: ChangeDetectionStrategy.Default,
})
export class FeedbackViewComponent implements AfterViewInit, OnInit {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild("feedbackListSort") feedbackListSort = new MatSort();
    @ViewChild(MatTableExporterDirective, { static: true })
    exporter: MatTableExporterDirective;

    constructor(
        private feedbackService: FeedbackService,
        private changeDetectorRef: ChangeDetectorRef,
        private spinner: NgxSpinnerService,
        private globalService: GlobalService,
        private router: Router,
        private route: ActivatedRoute,
        private platformLocation: PlatformLocation,
        private utcConverterService: UtcConverterService,
        @Inject(APP_BASE_HREF) private baseHref:string
    ) {
        this.chartCustomColors  = [
            { name: "1 star", value: 'darkred' },
            { name: "2 stars", value: 'lightcoral' },
            { name: "3 stars", value: 'green' },
            { name: "4 stars", value: 'silver' },
            { name: "5 stars", value: 'gold' },
    
        ]

    }

    //tooltip :{} = {}

    screenConfig: { [index: string]: any } = {
        admin: {
            title: "Work Order Feedback",
            instructions:
                "This section shows a list of feedback for requests. \
                Click anywhere in the row or use the far right 'Action' icons to view the feedback." 
        },
            
    };


    ROWS_PER_API_CALL = 1000;
    MAX_QUERY_IF_NO_FILTER = 1000;
    loadingMessage = "";
    systemDate: Date = this.globalService.getSystemDate();
    queryPerformed = false;
    chartCustomColors: any[] = [];
    overallStatsData : any[] = [];
    currentWorkRequest: WorkRequest;
    showFeedbackForm = false;

    //If we separate these into different values per mode, then make this an object keyed on mode.
    displayedColumns = [
        "wrNumber",
        "status",
        "action",
    ];

    //https://stackoverflow.com/questions/56833469/typescript-error-ts7053-element-implicitly-has-an-any-type
    displayColumns: { [index: string]: any } = {

     
        admin: [
            "wrNumber",
            "requestType",
            "subject",
            "requestorName",
            "submittedDateUTCShort",   
            "closedDateUTCShort",  
            "ratingDateUTCShort",   
            "rating",
            "action",
        ],
    };

    //checkboxes will not export.
    exportColumns = [
        "wrNumber",
        "requestType",
        "requestorName",
        "requestorEmail",
        "department",
        "subject",
        "businessRequirements",
        "requestSponsor",
        "desiredOutcome",
        "externalInvolvement",
        "requestNotes",
        "notes",
        "submittedDateUTC",   
        "closedDateUTC",  
        "ratingDateUTC",   
        "rating",
        "easeOfSupport",
        "supportComments",
        "opportunities",
        "additionalComments"
    ];

    tablePageSize = 25;
    tablePageSizeOptions = [10, 25, 50, 100];
    exportTablePageSize = 500;

    currentPageSize = this.tablePageSize;

    FILTER_PREFIX = "feedback_";

    PAGE_SIZE_LENGTH = this.FILTER_PREFIX + "pagesize";
       
    filterWorkRequestId: FormControl = new FormControl('');
    
    tableFilter: FormControl = new FormControl(null);

    filterDefaults: any = {
       
    };

    screenMode = GlobalConstants.FEEDBACK_FORM_MODE_ADMIN;
    screenTitles: ScreenConfig  = this.screenConfig[this.screenMode];


    workRequest?: WorkRequest;

    feedbackList: MatTableDataSource<IWorkRequestFeedback>;

    currentUser: AzureUser;

    //---------------------------------------------------------------
    // Lifecycle events
    //---------------------------------------------------------------
    ngOnInit(): void {
        this.feedbackList = new MatTableDataSource<IWorkRequestFeedback>();
        this.currentUser = getCurrentUserFromStorage();

        this.screenMode = GlobalConstants.REQUEST_FORM_MODE_USER;

        this.route.data.subscribe(data => {
            this.screenMode = data["mode"];
        })

        this.screenTitles = this.screenConfig[this.screenMode];
        this.displayedColumns = this.displayColumns[this.screenMode].map(
            (x: any) => x
        );

        this.getFeedbackList();
        this.getFeedbackStats();

        this.platformLocation.onPopState(() => {

            //console.log('pressed back!');
            if (this.showFeedbackForm) {
                this.closeFeedbackForm(null, true);
            }

        });
        

    }
    ngAfterViewInit() {
        this.setupSortAndFilters();
    }


    setupSortAndFilters() {
        this.feedbackList.paginator = this.paginator;
        
        this.feedbackList.sort = this.feedbackListSort;


        this.feedbackList.sortingDataAccessor = (item, property) => {
            switch (property) {
              case 'submittedDateUTCShort': return new Date(item.workRequest.submittedDateUTC||'');
              case 'ratingDateUTCShort': return new Date(item.createdDateUTC||'');
              case 'closedDateUTCShort': return new Date(item.workRequest.closedDateUTC||'');
              case 'rating': return new Date(item.rating||'');
              default: return item.workRequest[property];
            }
          };

          
          //let sortState : Sort = { active: "wrNumber", direction: "desc" };
          //use submitted date for admin
          let sortState: Sort = { active: "ratingDateUTCShort", direction: "desc" };
          
          
          this.feedbackListSort.active = sortState.active;
          this.feedbackListSort.direction = sortState.direction;
          this.feedbackListSort.sortChange.emit(sortState);
        
        this.feedbackList.filterPredicate = function (record, filter) {
            if (JSON.stringify(record).toLowerCase().indexOf(filter)!=-1) {
                //console.log(JSON.stringify(record));
                return true;
            } else {
                return false;
            }
        };
        

        this.tableFilter?.valueChanges.subscribe(() => {
            //this.applyTableSearch();
            let filterValue = this.tableFilter.value?.trim(); // Remove whitespace
            filterValue = filterValue?.toLowerCase()||''; // MatTableDataSource defaults to lowercase matches
            this.feedbackList.filter = filterValue; 
        });
        

        const storedPageLen = this.getFilterValueString(this.PAGE_SIZE_LENGTH);
        if (storedPageLen) {
            this.tablePageSize = storedPageLen;
        }

    }

    //Return the value from storage if it existed, or retuen the default value.
    //check for nulls, since one of the filters is a boolean
    public getFilterValueString(filter: string) {
        const selectVal = getFilterFromStorage(filter);
        let retStr = this.filterDefaults[filter];
        if (selectVal !== null) {
            retStr = String(selectVal);
        }
        return retStr;
    }

    public getFilterValue(filter: string): string[] {
        let retStr: string[] = [];
        const selectVal = getFilterFromStorage(filter);
        if (selectVal) {
            retStr = selectVal.toString().split(",");
        }
        return retStr;
    }

    clearSearch() {
        this.tableFilter.setValue(null);
    }

   
    getFeedbackStats() {

        this.feedbackService.getFeedbackStats().subscribe({
            next: (entries: any) => {
                for (let f of entries) {
                    this.overallStatsData = [...this.overallStatsData, { "name" : (f.rating + (f.rating === 1 ? " star" : " stars")), "value" : f.count}]
                }
            }
        });
           
    }

    getFeedbackList(): void {
        //this.overallStatsData = [ 
        //    { "name" : "1 star" , value : 0},
        //    { "name" : "2 stars" , value : 0},
        //    { "name" : "3 stars" , value : 0},
        //    { "name" : "4 stars", value : 0},
        //    { "name" : "5 stars" , value : 0}
        //];     

        this.feedbackList.data = [];
        this.spinner.show();
        const pagingOpts = { pageNumber: 1, pageSize: this.ROWS_PER_API_CALL, nextUrl: "" };
        const opts : IWorkRequestQueryOptions = {};
       
       
        this.getFeedbackListPage(pagingOpts, opts);
        this.queryPerformed = true;

    }

    getFeedbackListPage(pagingOpts: PagingOpts, opts: IWorkRequestQueryOptions): void {
        this.spinner.show();
       
        this.feedbackService.getFeedback(pagingOpts, opts).subscribe({
            next: (entries: any) => {
                this.feedbackList.data = [...this.feedbackList.data, ...entries.data];
               // for (let f of entries.data) {
               //     this.overallStatsData.find(i => i.name === (f.rating + (f.rating === 1 ? " star" : " stars"))).value++; 
               //     this.overallStatsData = [...[], ...this.overallStatsData]
               // }
                this.spinner.hide();
                if (entries.nextPage) {
                    
                    //this.expandFilters = false;
                    const currentTotal = entries.pageNumber * entries.pageSize;
                    this.loadingMessage = 'Loaded: ' + currentTotal.toLocaleString() + ' of ' + entries.totalRecords.toLocaleString() + ' records...';
                    //this.alertService.warn(this.loadingMessage, {autoClose: true});
                    pagingOpts.nextUrl = entries.nextPage;
                    if (Object.keys(opts).length > 0 || 
                       (Object.keys(opts).length == 0 && currentTotal < this.MAX_QUERY_IF_NO_FILTER)) {
                        this.getFeedbackListPage(pagingOpts, opts);
                    } else {
                        this.loadingMessage = ""; 
                    }
                }  else {
               
                    this.loadingMessage = "";
                
                }
                //console.log(this.overallStatsData);
                this.changeDetectorRef.detectChanges();
            },
            error: () => {
                this.spinner.hide();
            },
        });
    }

 

    showFeedback(feedback: IWorkRequestFeedback): void {
        setPreviousViewInStorage(this.router.url);

        //The feedback form gets the workrequest which includes feedback.  The view in this code is
        // feedback with a workrequest. (ie. the opposite, so format data to be passed)
        this.currentWorkRequest = feedback.workRequest;
        this.currentWorkRequest.feedback = feedback;
 
        //const route = "/feedback/view/" + workRequest.workRequestId;
        //this.router.navigateByUrl(route, {});
        this.showFeedbackForm = true;
        this.platformLocation.pushState(null,this.baseHref + "feedback/view/" + feedback.workRequestId, this.baseHref + "feedback/view/" + feedback.workRequestId);

    }

       /**
     * 
     * @param event 
     * @param isBrowserBackBtn 
     */
       closeFeedbackForm(event: any, isBrowserBackBtn?: boolean) {
        this.showFeedbackForm = false;

 
        //if an application button, then we goback on the stack entry we created.
        if (!isBrowserBackBtn) {
            this.platformLocation.back()
        }

    }

   
    //---------------------------------------------------------------
    // Utilities
    //---------------------------------------------------------------

    formatResource(obj: any, addRole : boolean) {
        let ret = "";
        if (obj == null || obj.length === 0 || obj[0]['name'] === '') {
            return "";
        } else {

            for (const i in obj) {
                ret += obj[i]['name']  + ( obj[i]['email'] ?  " : " + obj[i]['email'] : "");
                if (addRole) {
                    ret += " : " + obj[i]['role'];
                }
                ret += ", ";
            }
            return ret.substring(0, ret.length - 2);

        }
    }

    //This is all oaging events, but we will use it for storing pagesize.
    listingPageSizeChange(evt: any) {
        setFilterInStorage(this.PAGE_SIZE_LENGTH, evt.pageSize.toString());
    }

    //this is standard, but we need to ovveride
    //<button mat - raised - button(click)="exporter.exportTable('txt')" > Txt < /button>
    exportData(format: any) {
        //Change the columns shown in the table. The exporter will only export shown columns
        //We want the pagesize of the table to be large to scroll through it faster.
        this.spinner.show();
        this.displayedColumns = this.exportColumns.map((x) => x);
        this.currentPageSize = this.tablePageSize;
        this.tablePageSize = this.exportTablePageSize;

        this.changeDetectorRef.detectChanges();
        setTimeout(() => {
            this.exporter.exportTable(format, {
                fileName:
                    this.screenTitles.title +
                    `-${this.systemDate.toISOString()}`,
                Props: {
                    Author: GlobalConstants.siteTitle,
                },
            });
        }, 100);
        
    }

    /**
    * event when export is  completed.  reset the display
    */
    exportCompleted() {
        this.displayedColumns = this.displayColumns[this.screenMode].map(
            (x: any) => x
        );

        //Swal.fire("Export Completed.")
        this.tablePageSize = this.currentPageSize;
        //this.changeDetectorRef.detectChanges();
        this.spinner.hide();
    }

}
